'use client'

import { cn } from '@mntn-dev/ui-utilities'
import type { CSSProperties } from 'react'
import { Skeleton } from './skeleton.tsx'
import { type SkeletonTextSize, skeletonFontSizeMap } from './types.ts'

type SkeletonTextProps = {
  className?: string
  textSize?: SkeletonTextSize
  style?: CSSProperties
}

const SkeletonText = ({
  className,
  textSize = 'base',
  style,
}: SkeletonTextProps) => {
  return (
    <Skeleton
      className={cn('w-full rounded', skeletonFontSizeMap[textSize], className)}
      style={style}
    />
  )
}

export { SkeletonText, type SkeletonTextProps }
